import { EntitiesHelper } from "../helpers/entities.helper";
import { EnumTipoObjeto } from "../enums/EnumTipoObjeto";

export class OperacaoSignalR {
  public operationId: string;
  public userId: string;
  public tipoObjeto: EnumTipoObjeto;
  public dados: any;

  constructor() {
    this.operationId = EntitiesHelper.generateGuid();
  }
}
